export function isImageAttachment(file) {
  return Boolean(file && typeof file.type === 'string' && file.type.startsWith('image/'))
}
